import { clsx } from 'clsx';
import React, { FC, useState } from 'react';
import { Button } from 'atoms/Button';
import { Span } from 'atoms/Typography';
import { Reviews } from 'organisms/Filters/Reviews';
import { Sorting } from 'organisms/Filters/Sorting';
import { gtmPushFilters } from 'modules/gtm/modules/sections/productList/filters';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useMediaQuery } from 'modules/mui/hooks';
import {
  Brands,
  Genders,
  Materials,
  Size,
  Tags,
  Types,
} from './AttributeFilters';
import { Chips, ResultChips } from './Chips';
import { ColorButtonContainer } from './Color';
import { Mobile } from './Mobile';
import { RangePrices } from './RangePrices';
import { useFilters } from './hooks';
import styles from './styles.module.css';

export const Filters: FC = () => {
  const t = useTranslations();
  const { chipsState, facets, filters, handleReset, handleSearch } =
    useFilters();
  const { isMobile } = useMediaQuery();
  const [isFiltersOpen, setIsFiltersOpen] = useState(!isMobile);
  const [isShownAllFilters, setIsShownAllFilters] = useState(false);

  const toggleFilters = () => setIsFiltersOpen((prev) => !prev);

  const applyFilters = () => {
    handleSearch();

    gtmPushFilters(filters);
  };

  return !facets.length ? null : (
    <div className={styles.root}>
      {isMobile && <Mobile active={isFiltersOpen} onClick={toggleFilters} />}
      {isFiltersOpen && (
        <div className={styles.rows}>
          <div className={styles.row}>
            <div className={styles.rangeAndColorsWrapper}>
              <div className={styles.colors}>
                <ColorButtonContainer />
              </div>
              <RangePrices />
            </div>
            <Reviews />
            <Brands />
            <Sorting />
          </div>
          <div className={styles.row}>
            {chipsState?.position === 'top' && (
              <Chips isVisible={isFiltersOpen} />
            )}
            {isShownAllFilters && (
              <>
                <Size />
                <Genders />
                <Materials />
                <Tags />
                <Types />
              </>
            )}
            {chipsState?.position === 'bottom' && (
              <Chips isVisible={isFiltersOpen && isShownAllFilters} />
            )}
          </div>
          <Span
            className={styles.showMore}
            onClick={() => setIsShownAllFilters(!isShownAllFilters)}
          >
            <Span>{t(`search.${isShownAllFilters ? 'less' : 'more'}`)}</Span>
            {t('search.filter')}
          </Span>
        </div>
      )}
      <div
        className={clsx(
          styles.result,
          isFiltersOpen && styles.resultWithMargin,
        )}
      >
        <ResultChips list={filters} />
        {isFiltersOpen && (
          <div className={styles.actionButtons}>
            <Button onClick={handleReset}>{t('search.filters.reset')}</Button>
            <Button onClick={applyFilters}>{t('search.filters.apply')}</Button>
          </div>
        )}
      </div>
    </div>
  );
};
